'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var SolarHeating = function (_React$Component) {
    _inherits(SolarHeating, _React$Component);

    function SolarHeating() {
        _classCallCheck(this, SolarHeating);

        return _possibleConstructorReturn(this, (SolarHeating.__proto__ || Object.getPrototypeOf(SolarHeating)).apply(this, arguments));
    }

    _createClass(SolarHeating, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M20.59 6.599c-0.056-0.349-0.355-0.608-0.704-0.608h-14.132c-0.355 0-0.653 0.258-0.704 0.608l-1.758 11.533c-0.051 0.451 0.289 0.821 0.704 0.821h17.647c0.005 0 0.005 0 0.005 0 0.522 0 0.821-0.532 0.684-0.922l-1.742-11.432zM13.534 7.425h5.734l0.664 4.336h-6.397v-4.336zM12.105 17.525h-7.279l0.664-4.336h6.615v4.336zM12.105 11.761h-6.397l0.664-4.336h5.734v4.336zM13.534 17.525v-4.336h6.615l0.664 4.336h-7.279z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.427 19.348l-2.198-14.395c-0.157-1.054-1.048-1.818-2.117-1.818h-16.583c-1.069 0-1.96 0.765-2.117 1.818l-2.198 14.395c-0.213 1.094 0.755 2.553 2.117 2.467h8.008v5.622h-2.426c-0.395 0-0.714 0.319-0.714 0.714s0.319 0.714 0.714 0.714h9.816c0.395 0 0.714-0.319 0.714-0.714s-0.319-0.714-0.714-0.714h-2.426v-5.622h8.008c1.378-0.046 2.284-1.17 2.117-2.467zM13.873 27.437h-2.102v-5.622h2.102v5.622zM23.304 20.386h-20.969c-0.37 0.005-0.76-0.329-0.704-0.821l2.193-14.395c0.056-0.349 0.35-0.608 0.704-0.608h16.583c0.355 0 0.653 0.253 0.709 0.608l2.193 14.39c0.076 0.329-0.253 0.846-0.709 0.826z' })
            );
        }
    }]);

    return SolarHeating;
}(_react2.default.Component);

SolarHeating.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = SolarHeating;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/solar-heating.js
// module id = 1124
// module chunks = 0